module.exports = __webpack_public_path__ + "static/media/writing.d7e198f7.svg";